import axios from 'axios';
import Input from './validation/input';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();

class Form {
    constructor() {
        this.inputList = [];
    }

    init(options) {
        this.wrapper = options.target;
        this.popupInstanse = options.popupInstanse || null;
        this.form = options.target.querySelector('form');
        this.successMessage = options.successMessage;
        this.action = this.form.getAttribute('action');
        this.messageBot = this.form.querySelector('[name="message_bot"]');

        this._getElements();
        this._subscribes();
        this._bindEvents();
        this._setHiddenInput();
        this._setHiddenUrl();
    }

    /**
     * Метод получает дом элементы.
     * @private
     */
    _getElements() {
        this.submit = this.form.querySelector('.j-form-submit');
        this.submitText = this.submit.querySelector('.button__text');

        if (this.successMessage) {
            this.successMessageWrap = this.wrapper.querySelector('.j-form-success');
            this.errorMessageWrap = this.wrapper.querySelector('.j-form-error');
            this.returnForm = Array.from(this.wrapper.querySelectorAll('.j-form-return'));
        }
    }

    /**
     * Метод навешивает обработчики событий.
     * @private
     */
    _bindEvents() {
        if (!this.submit.hasAttribute('init')) {
            this.submit.setAttribute('init', 'true');

            this.submit.addEventListener('click', (event) => {
                event.preventDefault();
                this._send();
            });
        }

        if (this.returnForm.length) {
            this.returnForm.forEach((item) => {
                if (!item.hasAttribute('init')) {
                    item.setAttribute('init', 'true');

                    item.addEventListener('click', (event) => {
                        event.preventDefault();
                        this.closeResultMessage();
                    });
                }
            });
        }
    }

    /**
     * Метод содержит в себе коллбэки на события других модулей.
     * @private
     */
    _subscribes() {
        observer.subscribe('inputValidate', (input) => {
            this._changeState(input);
        });
    }

    /**
     * Метод создает инпут с опциями из конфига для валидации.
     * @param {object} options - опции для валидации инпута.
     */
    createInput(options) {
        const input = new Input();

        input.init(options);
        this.inputList.push(input);
    }

    /**
     * Метод оптправляет данные на сервер.
     * @private
     */
    _send() {
        if (!this.validateAll()) {
            return;
        }

        this._insertAntiSpam();
        this.formData = new FormData(this.form);
        this._insertButtonText('Отправляем...');

        axios.post(this.action, this.formData)
            .then((response) => {
                const status = response.data.request.status;

                if (status) {
                    this._sendIsSuccess();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                this._sendIsError();
                console.error(err);
            });
    }

    /**
     * Метод изменяет состояние валидации инпута при настпуплении соответствующего события.
     * @param {HTMLInputElement} input - инпут для которого нужно изменить состояние.
     * @private
     */
    _changeState(input) {
        this.inputList.forEach((item) => {
            if (item === input) {
                item.state = input.state;
            }
        });
    }

    /**
     * Метод запускает проверку валдиации для всех инпутов.
     * @return {boolean} - true/false успешная/неуспешная проверка.
     */
    validateAll() {
        let validate = true;

        this.inputList.forEach((item) => {
            if (!item.state) {
                item.throwError(item);
                validate = false;
            }
        });

        return validate;
    }

    /**
     * Метод вызывается при успешной отправке запроса.
     * @private
     */
    _sendIsSuccess() {
        Utils.hide(this.errorMessageWrap);
        this.submit.classList.remove('is-error');

        this._showSuccessMessage();
        this._sendMetrikaEvents();
        this._sendComagicData();
        this._insertButtonText('Отправлено');
        this.submit.classList.add('is-disabled');
        window.sessionStorage.removeItem('callback-init');
    }

    /**
     * Метод вызывается при ошибке отправки запроса.
     * @private
     */
    _sendIsError() {
        this._insertButtonText('Повторить отправку');
        this.errorMessageWrap.classList.add('is-show');
        this.submit.classList.add('is-error');

        this._showErrorMessage();
    }

    /**
     * Показывает сообщение об успешной отправкой формы.
     * @private
     */
    _showSuccessMessage() {
        Utils.show(this.successMessageWrap);
        Utils.hide(this.form);

        observer.publish('successForm');
        this._sendSeoSignal();
    }

    /**
     * Отправляет данные для сео
     * @private
     */
    _sendSeoSignal() {
        const popup = this.form.closest('[data-popup]');

        /* eslint-disable */
        if (popup) {
            if (popup.dataset.popup === '#callback-call') {
                dataLayer = dataLayer || [];
                dataLayer.push ({'event':'gaEvent', 'gaCategory':'form', 'gaAction':'send', 'gaLabel':'callback-header'});
                dataLayer.push ({'event': 'Pageview', 'pagePath': '/#form-send-callback-header','pageTitle': `${document.title} - Заказать звонок в шапке - отправка формы`});
            }

            if (popup.dataset.popup === '#callback-flat') {
                dataLayer = dataLayer || [];
                dataLayer.push ({'event':'gaEvent', 'gaCategory':'form', 'gaAction':'send', 'gaLabel':'flatRequest'});
                dataLayer.push ({'event': 'Pageview', 'pagePath': '/#form-send-flatRequest','pageTitle': `${document.title} - Заявка на апартаменты - отправка формы`});
            }
        }
        /* eslint-enable */
    }

    /**
     * Метод шлет события в Яндекс.Метрику при успешной отправке форм
     * @private
     */
    _sendMetrikaEvents() {
        if (this.form.classList.contains('ym-request') && window.ym) {
            window.ym(87230151, 'reachGoal', 'form_send');
        }
    }

    /**
     * Показывает сообщение об ошибке
     * @private
     */
    _showErrorMessage() {
        Utils.show(this.errorMessageWrap);
        Utils.hide(this.form);
    }

    /**
     * Метод закрывает все сообщения об отправке/неудаче
     */
    closeResultMessage() {
        Utils.hide(this.successMessageWrap);
        Utils.hide(this.errorMessageWrap);
        Utils.show(this.form);
    }

    /**
     * Метод вставляет текст в кнопку сабмит.
     * @param {string} text - необходимый текст.
     * @private
     */
    _insertButtonText(text) {
        if (this.submitText) {
            Utils.clearHtml(this.submitText);
            Utils.insetContent(this.submitText, text);
        }
    }

    /**
     * Метод вставляет скрытое поле с антиспамом
     */
    _insertAntiSpam() {
        if (this.messageBot) {
            const minRandom = 1;
            const maxRandom = 10;

            this.messageBot.value = `nospam ${Utils.random(minRandom, maxRandom)}`;
        }
    }

    /**
     * Метод сбразывает поля формы
     * @private
     */
    _resetForm() {
        this.inputList.forEach((item) => {
            item.clear();
        });

        this.form.reset();
    }

    /**
     * Устанавливает данные скрытому инпуту исходя из таргета попапа
     * @private
     */
    _setHiddenInput() {
        if (this.popupInstanse) {
            const input = this.popupInstanse.target.dataset.input;

            if (input) {
                const data = input.split(':');

                this.form.querySelector(`input[name=${data[0]}]`).value = data[1];
            }
        }
    }

    /**
     * При необходимости устанавливает текущий url в скрытый инпут
     * @private
     */
    _setHiddenUrl() {
        const input = this.form.querySelector('input[name=url]');

        if (input) {
            input.value = window.location.href;
        }
    }

    /**
     * Собираем и отправляем данные формы в Comagic
     * @private
     */
    _sendComagicData() {
        if (!window.Comagic || !window.Comagic.addOfflineRequest) {
            return;
        }

        const req = {
            name : this.formData.get('name') || '',
            phone: this.formData.get('phone') || ''
        };
        // eslint-disable-next-line
        console.log(`Данные: ${req.name} ${req.phone}`);
        const callbackLog = () => {
            // eslint-disable-next-line
            console.log('Отправили данные формы в Comagic');
        };

        window.Comagic.addOfflineRequest(req, callbackLog);
    }
}

export default Form;

